import { createBrowserRouter, Navigate } from 'react-router'

import { AppLayout } from '@/layouts/AppLayout'
import { AuthLayout } from '@/layouts/AuthLayout'

import { DEFAULT_AUTHENTICATED_ROUTE, ROUTES } from './constants'
import { RedirectIfAuthenticated, RequireAuth } from './RequireAuth'

/**
 * Дерево маршрутов хоста.
 *
 * Страницы грузятся лениво: экран входа не должен тащить за собой лейаут
 * соцсети, а лейаут — код авторизации. Продуктовые разделы вообще приезжают
 * ремоутами, и до первого перехода их код не нужен.
 */
export const router = createBrowserRouter([
  {
    element: <RedirectIfAuthenticated />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: ROUTES.login,
            lazy: async () => {
              const { LoginPage } = await import('@/pages/Login')
              return { Component: LoginPage }
            },
          },
          {
            path: ROUTES.register,
            lazy: async () => {
              const { RegisterPage } = await import('@/pages/Register')
              return { Component: RegisterPage }
            },
          },
        ],
      },
    ],
  },

  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: ROUTES.root, element: <Navigate to={DEFAULT_AUTHENTICATED_ROUTE} replace /> },
          {
            path: ROUTES.feed,
            lazy: async () => {
              const { FeedPage } = await import('@/pages/Feed')
              return { Component: FeedPage }
            },
          },
          {
            path: ROUTES.messages,
            lazy: async () => {
              const { SpacesPage } = await import('@/pages/Spaces')
              return { Component: SpacesPage }
            },
          },
          {
            path: ROUTES.space,
            lazy: async () => {
              const { SpacesPage } = await import('@/pages/Spaces')
              return { Component: SpacesPage }
            },
          },
          {
            path: ROUTES.notifications,
            lazy: async () => {
              const { NotificationsPage } = await import('@/pages/Notifications')
              return { Component: NotificationsPage }
            },
          },
          {
            path: ROUTES.bookmarks,
            lazy: async () => {
              const { BookmarksPage } = await import('@/pages/Bookmarks')
              return { Component: BookmarksPage }
            },
          },
          {
            path: ROUTES.profile,
            lazy: async () => {
              const { ProfilePage } = await import('@/pages/Profile')
              return { Component: ProfilePage }
            },
          },
          {
            path: ROUTES.settings,
            lazy: async () => {
              const { SettingsPage } = await import('@/pages/Settings')
              return { Component: SettingsPage }
            },
          },
        ],
      },
    ],
  },

  {
    path: '*',
    lazy: async () => {
      const { NotFoundPage } = await import('@/pages/NotFound')
      return { Component: NotFoundPage }
    },
  },
])
